import React from "react";
import Loader from "../../sharedComponents/loader/Loader";
import "./retrieveCalculationPopupContent.scss";
import { RequestStatus } from "../../../services/services/requestStatus";


interface RetrieveCalculationPopupContentProps {
  requestStatus: RequestStatus;
}

export default class RetrieveCalculationPopupContent extends React.Component<RetrieveCalculationPopupContentProps, any> {
  public render() {
    return (
      <div className={`popup-content-container`}>
        {this.renderContent()}
      </div>
    );
  }

  private renderContent() {
    const pending = this.props.requestStatus.isPending;
    const error = this.props.requestStatus.isError;
    const message = error ? "Wystąpił błąd poczas wczytywania danych" : "Wczytywanie danych...";

    return (
      <div className="popup-context">
        {message}
        <div className="popup-loader">
          {pending && <Loader />}
        </div>
      </div>
    );
  }
}
